<script lang="ts">
  import { location, push } from 'svelte-spa-router';
  import { getContext } from 'svelte';
  import EnecomUtil from '../util/EnecomUtil';
  import OperationCompleteModal from '../etc/modal/OperationCompleteModal.svelte';
  import { onMount } from 'svelte';
  import { temporaryLoginUser } from '../components/auth/TemporaryLoginUser';
  import Loading from '../etc/loader.svelte';
  import RepositoryFactory, { USERINFO } from '../repositories/RepositoryFactory';
  import { form, field } from 'svelte-forms';
  import { required, matchField } from 'svelte-forms/validators';

  $: $location;

  const isEnecom: boolean = EnecomUtil.isEnecom();
  const { open, close }: any = getContext('simple-modal');
  const accessToken = $location.replace('/reset/setting-password/', '');

  let canDisplay = false;

  onMount(async () => {
    /* 事前処理 */
    // cookieからユーザーを取得するようにする
    temporaryLoginUser.loginFromCookie();

    if (!$temporaryLoginUser) {
      window.location.href = '/404.html';
    }

    if (!accessToken) {
      window.location.href = '/404.html';
    }

    await verifyAccessTokenAsOnMount();
  });

  // input項目
  const password = field('password', '', [required()]);
  const confirmPassword = field('confirmPassword', '', [matchField(password)]);
  const myForm = form(password, confirmPassword);

  // エラーメッセージ
  let errorMessage: string = '';

  const verifyAccessTokenAsOnMount = () => {
    const userinfoRepository = RepositoryFactory[USERINFO];
    userinfoRepository
      .verifyAccessToken({
        accountId: $temporaryLoginUser.accountId,
        accessToken: accessToken
      })
      .then((response) => {
        if (response) {
          canDisplay = response.isValidToken;
        }
      })
      .catch((error) => {
        if (error.response?.status === 403) {
          alert('パスワード変更有効期限が切れました。「パスワードを忘れた方」より再度変更作業をしてください');
          temporaryLoginUser.logout();
          push('/reset/login-info/');
        } else {
          alert('エラーが発生しました。');
        }
        canDisplay = false;
      });

    if (canDisplay) {
      window.location.href = '/404.html';
    }
  };

  const verifyAccessToken = async () => {
    let result = false;
    const userinfoRepository = RepositoryFactory[USERINFO];
    await userinfoRepository
      .verifyAccessToken({
        accountId: $temporaryLoginUser.accountId,
        accessToken: accessToken
      })
      .then((response) => {
        if (response) {
          result = response.isValidToken;
        }
      })
      .catch((error) => {
        // 認証エラーを判定
        switch (error.response?.status) {
          case 401:
          case 403:
          case 404:
            result = false;
            break;
        }
        result = false;
      });
    return result;
  };

  const handleChangeSettingPassword = async () => {
    errorMessage = '';

    let isFormValid = false;
    await myForm.validate().then(() => {
      isFormValid = $myForm.valid;
    });
    if (!isFormValid) {
      return false;
    }

    const isValidToken = await verifyAccessToken();
    if (!isValidToken) {
      errorMessage = 'パスワード変更有効期限が切れました';
      return;
    }

    const userinfoRepository = RepositoryFactory[USERINFO];
    userinfoRepository
      .changeSettingPassword({
        loginUserInfoId: $temporaryLoginUser.loginUserInfoId,
        accountId: $temporaryLoginUser.accountId,
        accessToken,
        password: $password.value
      })
      .then((response) => {
        showSuccessedModal();
      })
      .catch((error) => {
        // 認証エラーを判定
        switch (error.response?.status) {
          case 401:
          case 403:
          case 404:
            errorMessage = 'パスワード変更に失敗しました';
            return;
        }
        errorMessage = 'パスワード変更に失敗しました';
        return;
      });
  };

  const showSuccessedModal = () => {
    open(
      OperationCompleteModal,
      {
        modalTitle: 'パスワードを変更しました',
        modalMessage: 'ご登録のメールアドレスに パスワード変更完了メール を送信しました',
        handleCloseEvent: () => {
          temporaryLoginUser.logout();
          push(`/login`);
          close();
        }
      },
      {
        closeButton: false,
        closeOnEsc: false,
        closeOnOuterClick: false
      }
    );
  };
</script>

<!-- 本体 -->
{#if !canDisplay}
  <Loading />
{:else}
  <div class="md:h-screen flex flex-col justify-between items-center login-background">
    <header class="container top-0 z-0">
      <div class="justify-between items-center" style="height:56px">
        {#if isEnecom}
          <img style="height:36px" class="object-none w-full" src="/image/enecom_logo.png" alt="logo" />
        {:else}
          <img style="height:36px" class="object-none w-full" src="/image/unext_communication_logo.svg" alt="logo" />
        {/if}
        <hr class="items-center" style="border: 1px solid rgba(0,10,23,0.2)" />
      </div>
    </header>

    <main class="container mt-20 mb-auto">
      <div class="grid place-items-center text-3xl">パスワード確認・変更</div>

      {#if errorMessage !== ''}
        <div class="grid place-items-center mt-10">
          <div class="content-center shadow-sm alert-background">
            <div class="bg-red-100 border-red-500 text-red-700 px-4 py-3" role="alert">
              <p class="font-bold">
                {errorMessage}
              </p>
            </div>
          </div>
        </div>
      {/if}

      <div class="grid place-items-center mt-10">
        <div class="content-center shadow-sm p-5 form-background">
          <form>
            <div class="grid place-items-center">
              <div class="form-container">
                <div>
                  <label for="password" class="block mt-4 form-input-label">パスワード</label>
                  <input
                    type="password"
                    id="password"
                    name="password"
                    class="block p-3 mt-1 appearance-none"
                    bind:value={$password.value}
                    required
                  />
                  {#if $myForm.hasError('password.required')}
                    <p class="text-red-500 text-xs mt-2">パスワードを入力してください</p>
                  {/if}
                </div>

                <div>
                  <label for="password" class="block mt-4 form-input-label">パスワードの確認入力</label>
                  <input
                    type="password"
                    id="confirmPassword"
                    name="confirmPassword"
                    class="block p-3 mt-1 appearance-none"
                    bind:value={$confirmPassword.value}
                    required
                  />
                  {#if $myForm.hasError('confirmPassword.match_field')}
                    <p class="text-red-500 text-xs mt-2">パスワードが確認用パスワードと一致していません</p>
                  {/if}
                </div>

                <button
                  type="button"
                  class="py-3 mt-10 tracking-widest form-button"
                  on:click={handleChangeSettingPassword}>変更する</button
                >
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="grid place-items-center mt-10">
        <div class="content-center shadow-sm p-5 warning-background">
          <div class="grid place-items-start text-base">
            <div class="content-help-title">Gmailをご利用の方</div>
            <div class="content-help-text">メールが届かない場合は迷惑メールボックスをご確認ください。</div>
          </div>
          <div class="grid place-items-start text-base mt-5">
            <p class="content-help-title">そのほかのメールをご利用の方</p>
            <p class="content-help-text">
              メールが届かない場合は迷惑メールボックスをご確認ください。@unext.jpから送信したメールが迷惑メールと判断されてメールが届かないことがあります。受信できるように設定してください。
            </p>
          </div>
        </div>
      </div>
    </main>

    <footer class="container" />
  </div>
{/if}

<style lang="postcss">
  .login-background {
    background-color: white;
  }
  .content-help-title {
    color: #404040;
    font-size: 16px;
    font-weight: bold;
  }
  .content-help-text {
    color: #404040;
    font-size: 14px;
  }
  input[type='password'] {
    font-size: 14px;
    color: rgba(0, 10, 23, 1);
    background-color: rgba(1, 6, 13, 0.06);
    width: 100%;
    height: 48px;
    @apply focus:ring-0 focus:ring-blue-200 focus:border-transparent;
  }
  .form-background {
    width: 720px;
    background-color: rgba(0, 0, 0, 0.02);
  }
  @media screen and (max-width: 640px) {
    .form-background {
      width: 100%;
    }
  }
  .warning-background {
    width: 720px;
    background-color: rgba(0, 0, 0, 0.12);
  }
  @media screen and (max-width: 640px) {
    .warning-background {
      width: 100%;
    }
  }
  .form-input-label {
    font-size: 16px;
    color: rgba(0, 0, 0, 1);
  }
  .form-button {
    font-size: 14px;
    font-weight: bold;
    color: #ffffff;
    background-color: #0fb9f5;
    width: 100%;
    height: 56px;
  }
  .form-button:hover {
    text-decoration: none;
    -webkit-filter: brightness(1.1);
    filter: brightness(1.1);
  }
  .form-container {
    width: 352px;
  }
  @media screen and (max-width: 640px) {
    .form-container {
      width: 100%;
    }
  }
</style>
